/**
 * Pennylane-style OAuth credentials: refresh token TTL is created_at (unix s) + refresh_token_expires_in (s).
 * If expiry fields are missing (legacy rows), we only require a non-empty refresh_token.
 *
 * @param {Record<string, unknown> | null | undefined} credentials
 * @returns {boolean}
 */
export const isOAuth2RefreshTokenStillValid = (credentials) => {
  if (!credentials || typeof credentials !== 'object') {
    return false;
  }

  const refreshToken = credentials.refresh_token;

  if (typeof refreshToken !== 'string' || refreshToken.trim() === '') {
    return false;
  }

  const createdAt = Number(credentials.created_at);
  const refreshExpiresIn = Number(credentials.refresh_token_expires_in);

  if (!Number.isFinite(createdAt) || !Number.isFinite(refreshExpiresIn)) {
    return true;
  }

  if (createdAt <= 0 || refreshExpiresIn < 0) {
    return false;
  }

  const nowSeconds = Date.now() / 1000;
  const refreshExpiresAt = createdAt + refreshExpiresIn;

  return nowSeconds < refreshExpiresAt;
};
